<template>
    <div class="flex min-h-0 flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <slot />
    </div>
</template>
